const toNumber = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : 0;
};

/**
 * The existing-source figures behind the annual summary cards.
 *
 * Without a Settle chain they come from the Consumption node, which subtracts Existing OA itself.
 * With one, the Consumption node emits the original profile and the existing sources are settled
 * downstream, so the figures are summed across every Settle source and the balance is the demand
 * the last source handed to the Matcher.
 *
 * `fromConsumption` carries the Consumption node's own figures; `settleSummary` is the
 * /analysis/source_settlement_summary response.
 *
 * A Settle source replaces its same-hour units plus the units it banked, so `existingOaReUnits`
 * includes banked units there. That keeps existing + proposed replacement adding up to the demand.
 */
export const resolveExistingSourceMetrics = (settleSummary, fromConsumption) => {
  const combined = settleSummary && settleSummary.available && settleSummary.combined ? settleSummary.combined : null;

  if (!combined) {
    const existingOaReUnits = toNumber(fromConsumption.existingOaReUnits);
    const existingOaBankedUnits = toNumber(fromConsumption.existingOaBankedUnits);
    return {
      fromSettleChain: false,
      balanceAnnualConsumption: toNumber(fromConsumption.balanceAnnualConsumption),
      originalAnnualConsumption: toNumber(fromConsumption.originalAnnualConsumption),
      existingOaReUnits,
      existingOaBankedUnits,
      existingOaLapsedUnits: toNumber(fromConsumption.existingOaLapsedUnits),
      existingOaServedUnits: existingOaReUnits + existingOaBankedUnits,
    };
  }

  const existingOaBankedUnits = toNumber(combined.banked);
  const existingOaReUnits = toNumber(combined.same_hour) + existingOaBankedUnits;
  return {
    fromSettleChain: true,
    balanceAnnualConsumption: toNumber(combined.residual_to_proposal),
    originalAnnualConsumption: toNumber(fromConsumption.originalAnnualConsumption) || toNumber(combined.original_demand),
    existingOaReUnits,
    existingOaBankedUnits,
    existingOaLapsedUnits: toNumber(combined.surplus_after_bank),
    existingOaServedUnits: existingOaReUnits,
  };
};
